import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { disableAutoShutdown, enableAutoShutdown, getAutoShutdownStatus } from "../../../services/aws/rds";

/**
 * Component for managing database auto-shutdown functionality.
 * 
 * @component
 * @example
 * return (
 *   <DatabaseAutoShutdown />
 * )
 * 
 * @returns {JSX.Element} Card containing auto-shutdown controls with enable/disable buttons
 */
function DatabaseAutoShutdown() {
  const [autoShutdownEnabled, setAutoShutdownEnabled] = useState(false);

  useEffect(() => {
    fetchStatus();
  }, []);

  /**
   * Fetch current auto-shutdown status
   */
  const fetchStatus = async () => {
    try {
      const response = await getAutoShutdownStatus();
      const json = await response.json();

      if (json && json.status === "success") {
        setAutoShutdownEnabled(json.data.is_enabled);
      }
    } catch (error) {
      console.error("Error fetching auto-shutdown status:", error);
    }
  };

  /**
   * Enable database auto-shutdown
   */
  const handleEnableAutoShutdown = async () => {
    try {
      const response = await enableAutoShutdown();
      const jsonResponse = await response.json();
      if (jsonResponse && jsonResponse.status === "success") {
        fetchStatus();
      }
    } catch (error) {
      console.error("Failed to enable auto-shutdown:", error);
    }
  };

  /**
   * Disable database auto-shutdown
   */
  const handleDisableAutoShutdown = async () => {
    try {
      const response = await disableAutoShutdown();
      const jsonResponse = await response.json();
      if (jsonResponse && jsonResponse.status === "success") {
        fetchStatus();
      }
    } catch (error) {
      console.error("Failed to disable auto-shutdown:", error);
    }
  };

  return (
    <Card sx={{ width: "100%" }}>
      <CardContent>
        <Typography variant="h6" component="div" sx={{ m: 2 }}>
          Status: {autoShutdownEnabled ? "ENABLED" : "DISABLED"}
        </Typography>
        <Box sx={{ display: "flex", gap: 2, m: 2 }}>
          <Button variant="contained" color="primary" disabled={autoShutdownEnabled} onClick={handleEnableAutoShutdown}>
            Enable Auto-Shutdown
          </Button>
          <Button variant="contained" color="error" disabled={!autoShutdownEnabled} onClick={handleDisableAutoShutdown}>
            Disable Auto-Shutdown
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default DatabaseAutoShutdown;
